import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TemplateManage from '@/views/marketing/marketingManage/templateManage/index.vue'


const __default__ = { name: 'DcCosLbuTemplateManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'lbu_tpl_add_btn',
  del: 'lbu_tpl_del_btn',
  edit: 'lbu_tpl_edit_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TemplateManage, {
    subdomain: "lbu",
    permission: permission
  }))
}
}

})